// extracted by mini-css-extract-plugin
export default {"formBox":"contact_formBox__yGooJ","form":"contact_form__aPIxT","map":"contact_map__qy0Pr"};